export const ERROR_NAME_NOT_ALLOWED = 'Oops! There is already a project with this name!';
export const ERROR_DEFAULT = 'Oops, something went wrong! Try again.';
export const SUCCESS_UPDATE_DEFAULT = 'The project name was successfully updated!';
export const ERROR_NAME_SUSPENDED_WORKSPACE = 'Oops! You can’t edit the project name of a suspended workspace.';
export const SUCCESS_DOWNLOAD = 'Your project is being downloaded.';
